function prepareTableColumnsWithQueryParams(
  columns: any,
  selectedParams: URLSearchParams
) {
  const filtersParam = selectedParams.get("filters");
  const sortByParam = selectedParams.get("sortBy");
  const sortOrderParam = selectedParams.get("sortOrder");
  const statusParam = selectedParams.get("status");
  const typeParam = selectedParams.get("type");
  const methodParam = selectedParams.get("method");
  const statusCodeParam = selectedParams.get("statusCode");

  const platformColIdx = columns?.findIndex(
    (item: any) => item?.key === "platforms"
  );

  const statusColIdx = columns?.findIndex(
    (item: any) => item?.key === "status"
  );

  const typeColIdx = columns?.findIndex((item: any) => item?.key === "type");

  const sortByColIdx = sortByParam
    ? columns?.findIndex((item: any) => item?.key === sortByParam)
    : -1;

  const statusCodeColIdx = columns?.findIndex(
    (item: any) => item?.key === "status_code"
  );

  const methodColIdx = columns?.findIndex(
    (item: any) => item?.key === "method"
  );

  if (platformColIdx !== -1) {
    columns[platformColIdx].filteredValue =
      filtersParam && filtersParam?.length > 0 ? filtersParam?.split(",") : [];
  }

  if (typeColIdx !== -1) {
    columns[typeColIdx].filteredValue =
      typeParam && typeParam?.length > 0 ? typeParam?.split(",") : [];
  }

  if (statusColIdx !== -1) {
    columns[statusColIdx].filteredValue =
      statusParam && statusParam?.length > 0 ? statusParam?.split(",") : [];
  }

  if (statusCodeColIdx !== -1) {
    columns[statusCodeColIdx].filteredValue =
      statusCodeParam && statusCodeParam?.length > 0
        ? statusCodeParam?.split(",")
        : [];
  }

  if (methodColIdx !== -1) {
    columns[methodColIdx].filteredValue =
      methodParam && methodParam?.length > 0 ? methodParam?.split(",") : [];
  }

  if (sortByColIdx !== -1) {
    if (sortOrderParam) {
      columns[sortByColIdx].sortOrder =
        sortOrderParam === "asc" ? "ascend" : "descend";

      columns.forEach((col: any, idx: number) => {
        if (idx !== sortByColIdx) {
          col.sortOrder = null;
        }
      });
    } else {
      columns[sortByColIdx].sortOrder = "descend";
    }
  }

  return [...columns];
}

export { prepareTableColumnsWithQueryParams };
